import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { ThemePalette, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { MachineDB_controller } from 'src/app/Services/DB_Controller/MachineDB_controller';
import { PartDB_controller } from 'src/app/Services/DB_Controller/PartDB_controller';
import { PODB_controller } from 'src/app/Services/DB_Controller/PODB_controller';
import { Machine } from 'src/app/Services/Object_Classes/Machine/Machine';
import { Part } from 'src/app/Services/Object_Classes/Part/Part';
import { PurchaseOrder, PartTracker } from 'src/app/Services/Object_Classes/PurchaseOrder/PurchaseOrder';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { ViewRawMaterialsComponent } from 'src/app/Shared/view-raw-materials/view-raw-materials.component';
import { SelectMachineSlotComponent } from '../../scheduling/add-event/select-machine-slot/select-machine-slot.component';
import { v4 as uuidv4 } from 'uuid';
import { AngularFirestore } from '@angular/fire/firestore';
import { Customer } from 'src/app/Services/Object_Classes/Customer/Customer';
import { CustomerDB_controller } from 'src/app/Services/DB_Controller/CustomerDB_controller';
import { AddPartComponent } from '../../parts/PopUpModal/add-part/add-part.component';
import { StaffDB_controller } from 'src/app/Services/DB_Controller/StaffDB_controller';
import { Staff } from 'src/app/Services/Object_Classes/Staff/Staff';
import { WeightingDB_controller } from 'src/app/Services/DB_Controller/WeightingDB_controller';

@Component({
  selector: 'app-qc-rejection',
  templateUrl: './qc-rejection.component.html',
  styleUrls: ['./qc-rejection.component.css']
})
export class QCRejectionComponent implements OnInit {

  inspectionTypes = ['INCOMING INSPECTION', 'IN-PROCESS INSPECTION', 'OUT-GOING INSPECTION', 'CUSTOMER'];
  rejectionTypes = ['MISSING PROCESS', 'DENTED OR SCRATCHES', 'SURFACE FINISHING', 'BENDING ISSUES', 'DIMENSION OUT', 'CHAMFERING OR TAPPING ISSUES', 'POLISHING DIRECTION', 'ENGRAVING', 'WRAPPING', 'OTHERS'];

  addQCModel: any;
  inspectionNo = 0;
  poNo: any;
  joNo: any;
  totalPart: any;
  partNumber: any;
  quantity: any;
  part: Part = new Part();
  part_controller: PartDB_controller = new PartDB_controller(this.db,this.storage,this.firestore);
  po_controller: PODB_controller = new PODB_controller(this.db);
  CustomerDB_controller: CustomerDB_controller = new CustomerDB_controller(this.db,this.firestore);
  StaffDB_controller: StaffDB_controller = new StaffDB_controller(this.db, this.firestore);
  weighting_Controller = new WeightingDB_controller(this.db);
  partlist: Part[] = [];
  matSelectCustomer: Customer[] = [];
  customerlist: Customer[] = [];
  matSelectPart: Part[] = [];
  clone = [];
  runningScheduleList = [];
  estimateTotalTime = [];
  choosingPart= [];
  timeslots = [];
  dateslots = [];
  addForm: FormGroup;
  newPO: PurchaseOrder = new PurchaseOrder();
  newPO_PartList: PartTracker[] = [];
  searchPart: any;
  email: string;
  existingName = false;
  customerName = '';
  staffName = '';
  check = false;
  Staff: Staff[] = [];
  CloneStaff: Staff[] = [];
  @ViewChild('picker', {static: true}) picker: any;

  public date: moment.Moment;
  public minDate: moment.Moment;
  public maxDate: moment.Moment;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';

  public formGroup = new FormGroup({
    date: new FormControl(null, [Validators.required]),
    date2: new FormControl(null, [Validators.required])
  });

  public options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ];

  constructor(
    private dialogRef: MatDialogRef<QCRejectionComponent>,
    private fb: FormBuilder,
    private toast: ToastrService,
    private db: AngularFireDatabase,
    private storage: AngularFireStorage,
    private dialog: MatDialog,
    private angularFireAuth: AngularFireAuth,
    private firestore: AngularFirestore,
    private spinner : NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.addForm = this.fb.group({
      Occurence: '',
      ToProdSupplier: '',
      refNumber: data.rev,
      drawingDesc: '',
      issuedDate: '',
      lotSize: data.lotSize,
      drawingNo: data.drawingNo,
      parts: this.fb.array([]),
    });

    this.addQCModel = data;

    this.angularFireAuth.authState.subscribe(auth=>{
      this.email = auth.email;
    });
  }

  ngOnInit() {}

  parts(): FormArray {
    return this.addForm.get('parts') as FormArray;
  }

  samples(i): FormArray {
    return this.parts().at(i).get('samples') as FormArray;
  }

  newParts(): FormGroup {
    const Reason = new FormControl();
    const Quantity = new FormControl();
    const Remarks = new FormControl();

    return this.fb.group({
      Reason,
      Quantity,
      Remarks,
    });
  }

  addParts() {
    this.parts().push(this.newParts());
    this.partlist.push(null);
  }

  removeParts(i: number) {
    this.parts().removeAt(i);
    this.partlist.splice(i, 1);
  }

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    if(this.addForm.get('Occurence').value == null || this.addForm.get('Occurence').value == ''){
      this.toast.error('Please choose where the failure occured', 'Please change!');
      return;
    }

    if(this.addForm.get('ToProdSupplier').value == null || this.addForm.get('ToProdSupplier').value == ''){
      this.toast.error('Please choose assigned to who', 'Please enter assignee!');
      return;
    }

    if(this.addForm.get('refNumber').value == null || this.addForm.get('refNumber').value == ''){
      this.toast.error('Please Enter Reference Number', 'Please enter Reference Number!');
      return;
    }

    if(this.addForm.get('drawingDesc').value == null || this.addForm.get('drawingDesc').value == ''){
      this.toast.error('Please enter drawing description', 'Please enter drawing description!');
      return;
    }

    if(this.addForm.get('issuedDate').value == null || this.addForm.get('issuedDate').value == ''){
      this.toast.error('Please Enter Issued Date', 'Please enter Issued Date!');
      return;
    }


    if(this.addForm.get('lotSize').value == null || this.addForm.get('lotSize').value == ''){
      this.toast.error('Please Enter Lot Size', 'Please enter lot size!');
      return;
    }

    if(this.addForm.get('drawingNo').value == null || this.addForm.get('drawingNo').value == ''){
      this.toast.error('Please Enter Drawing No', 'Please Enter Drawing Number!');
      return;
    }

    const addPOModel = {
      Occurence : this.addForm.get('Occurence').value,
      ToProdSupplier : this.addForm.get('ToProdSupplier').value,
      refNumber : this.addForm.get('refNumber').value,
      drawingDesc : this.addForm.get('drawingDesc').value,
      issuedDate : this.addForm.get('issuedDate').value,
      lotSize : this.addForm.get('lotSize').value,
      drawingNo : this.addForm.get('drawingNo').value,
      parts: []
    };

    const parts = this.addForm.get('parts').value;
    parts.forEach((element, index) => {
      const info = {
        Reason: element.Reason,
        Quantity: element.Quantity,
        Remarks: element.Remarks || ''
      };

      if ( !info.Reason|| !info.Quantity ) {
        this.toast.error('Reson information(' + (index + 1) + ') not completed!', 'Please fill in');
        return;
      }

      addPOModel.parts.push(info);
    });

    if (addPOModel.parts.length === 0) {
      this.toast.error('Please add at least one reason', 'Add Reason');
      return;
    }

    if(addPOModel.parts.length !== this.partlist.length){
      this.toast.error('Form not completed', 'Form');
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = '50%';
    const position = {
      top: '5%'
    };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm this QC Inspection Records?';

    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(result => {
      if (result) {
        this.weighting_Controller.updateRejectedQCWithoutSchedule(this.addQCModel, addPOModel, this.email);
        this.dialogRef.close(addPOModel);
      }
    });
  }

  getRandomString(length) {
    let randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for ( let i = 0; i < length; i++ ) {
        result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  getPart(formindex){
    var partNo = $('#partNo').val();
    const samePart = this.matSelectPart.find(c=>c.Part_No === partNo);
    
    if (samePart) {
      this.part_controller.search_Part(partNo.toString()).then(data => {
        this.partlist[formindex] = data;
        const info = {
          part:partNo,
          index: formindex,
        }

        //this.choosingPart.push(info);
      });
    }
  }

  parFloat(value){
    return parseFloat(value);
  }
}
